import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface FilterTabProps {
  searchFieldState: {
    selectedUnit: DonViCoSo | null;
    setSelectedUnit: (unit: DonViCoSo | null) => void;
  };
}

const FilterTab = ({ searchFieldState }: FilterTabProps) => {
  return (
    <div className='p-4'>
      {/* Đơn vị */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          type='text'
          name='ma_unit'
          searchEndpoint={`/${QUERY_KEYS.DON_VI}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={searchFieldState.selectedUnit?.ma_unit}
          relatedFieldValue={searchFieldState.selectedUnit?.ten_unit}
          onRowSelection={searchFieldState.setSelectedUnit}
        />
      </div>

      {/* Trạng thái */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '0', label: 'Chưa ghi sổ' },
            { value: '3', label: 'Chờ duyệt' },
            { value: '5', label: 'Đã ghi sổ' },
            { value: '6', label: 'Đang thực hiện' },
            { value: '7', label: 'Hoàn thành' },
            { value: '8', label: 'Nhập quỹ' },
            { value: '9', label: 'Hủy' }
          ]}
        />
      </div>

      {/* Lọc theo người SD */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Lọc theo người SD</Label>
        <FormField
          name='user_id0'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '1', label: 'Lọc theo người tạo' }
          ]}
        />
      </div>
    </div>
  );
};

export default FilterTab;
